import { ReactNode, useEffect } from 'react'

import { ReactComponent as AccountCardIcon } from 'assets/icons/drawer/account_card.svg'
import { ReactComponent as BellIcon } from 'assets/icons/drawer/bell.svg'
import { ReactComponent as BriefCaseIcon } from 'assets/icons/drawer/briefcase.svg'
import { ReactComponent as BulletedIcon } from 'assets/icons/drawer/bulleted.svg'
import { ReactComponent as CardIcon } from 'assets/icons/drawer/card.svg'
import { ReactComponent as ContractIcon } from 'assets/icons/drawer/contract.svg'
import { ReactComponent as DocumentMultiple } from 'assets/icons/drawer/document_multiple.svg'
import { ReactComponent as DocumentIcon } from 'assets/icons/drawer/document.svg'
import { ReactComponent as DoubleFilesIcon } from 'assets/icons/drawer/double_files.svg'
import { ReactComponent as FileCheckIcon } from 'assets/icons/drawer/file_check.svg'
import { ReactComponent as FileMultipleIcon } from 'assets/icons/drawer/file_multiple.svg'
import { ReactComponent as GraphicIcon } from 'assets/icons/drawer/graphic.svg'
import { ReactComponent as PersonIcon } from 'assets/icons/drawer/person.svg'
import { ReactComponent as PieChart } from 'assets/icons/drawer/pie_chart.svg'
import { ReactComponent as SearchIcon } from 'assets/icons/drawer/search.svg'
import { ReactComponent as TalkToUsIcon } from 'assets/icons/drawer/talk-to-us.svg'
import useAuth from 'hooks/useAuth'
import BugReportIcon from '@mui/icons-material/BugReport'






export const PERMITIONS = {
  ADMINISTRADOR: 1,
  CSNCONTRAPARTE: 6,
  CSNSEGURANCALOGICA: 8,
  CSNTI: 7,
  FORNECEDORADMINISTRADOR: 9,
  FORNECEDOROPERADORGST: 11,
  FORNECEDOROPERADORHIBRIDO: 12,
  FORNECEDOROPERADORNGT: 10,
  GSTANALISTA: 5,
  GSTNORMATIVO: 4,
  NGTANALISTA: 3,
  NGTNORMATIVO: 2
}

const supplierRoutesList = [
  {
    icon: <DocumentMultiple className="icon_drawer" />,
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.FORNECEDORADMINISTRADOR,
      PERMITIONS.FORNECEDOROPERADORNGT,
      PERMITIONS.FORNECEDOROPERADORGST,
      PERMITIONS.FORNECEDOROPERADORHIBRIDO
    ],
    selected: false,
    subRoutes: [
      {
        disable: false,
        path: '/movimentacao',
        permition: [
          PERMITIONS.ADMINISTRADOR,
          PERMITIONS.FORNECEDORADMINISTRADOR,
          PERMITIONS.FORNECEDOROPERADORNGT,
          //PERMITIONS.FORNECEDOROPERADORGST,
          PERMITIONS.FORNECEDOROPERADORHIBRIDO
        ],
        selected: false,
        title: 'Movimentação Mensal'
      },
      // Comentado por solicitação do Jose Maykol dia 30/04/2024.
      {
        disable: false,
        path: '/fornecedor/efetivos/cadastro-efetivo',
        permition: [
          PERMITIONS.ADMINISTRADOR,
          PERMITIONS.FORNECEDORADMINISTRADOR,
          PERMITIONS.FORNECEDOROPERADORNGT,
          PERMITIONS.FORNECEDOROPERADORGST,
          PERMITIONS.FORNECEDOROPERADORHIBRIDO
        ],
        selected: false,
        title: 'Cadastro Efetivo Lógico'
      },
      {
        disable: false,
        path: '/fornecedor/efetivos/cadastro-efetivo',
        permition: [PERMITIONS.CSNCONTRAPARTE],
        selected: false,
        title: 'Cadastro Efetivo Lógico'
      },
      {
        path: 'voltar',
        permition: [],
        title: 'Voltar'
      }
    ],
    title: 'Efetivo'
  },
  {
    icon: <DoubleFilesIcon className="icon_drawer" />,
    permition: [
      PERMITIONS.FORNECEDOROPERADORGST,
      //PERMITIONS.CSNCONTRAPARTE,
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.FORNECEDORADMINISTRADOR,
      PERMITIONS.FORNECEDOROPERADORNGT,
      PERMITIONS.FORNECEDOROPERADORHIBRIDO
    ],
    selected: false,
    subRoutes: [
      {
        disable: false,
        path: '/fornecedor/anexar-documentos/gestao-terceiros',
        permition: [
          PERMITIONS.ADMINISTRADOR,
          //PERMITIONS.CSNCONTRAPARTE,
          PERMITIONS.FORNECEDORADMINISTRADOR,
          PERMITIONS.FORNECEDOROPERADORNGT,
          PERMITIONS.FORNECEDOROPERADORHIBRIDO
        ],
        selected: false,
        title: 'Gestão de Terceiros'
      },
      {
        disable: false,
        path: '/fornecedor/anexar-documentos/gst',
        permition: [
          PERMITIONS.ADMINISTRADOR,
          PERMITIONS.FORNECEDORADMINISTRADOR,
          PERMITIONS.FORNECEDOROPERADORGST,
          PERMITIONS.FORNECEDOROPERADORHIBRIDO
        ],
        selected: false,
        title: 'Gestão de Segurança do Trabalho'
      },
      {
        path: 'voltar',
        permition: [],
        title: 'Voltar'
      }
    ],
    title: 'Anexar Documentos'
  },
  {
    icon: <PersonIcon className="icon_drawer" />,
    path: '/fornecedor/usuarios',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.FORNECEDORADMINISTRADOR,
      PERMITIONS.FORNECEDOROPERADORGST,
      PERMITIONS.FORNECEDOROPERADORNGT,
      PERMITIONS.FORNECEDOROPERADORHIBRIDO
    ],
    selected: false,
    subRoutes: [],
    title: 'Usuarios'
  },
  {
    icon: <BellIcon className="icon_drawer" />,
    path: '/fornecedor/contato',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.FORNECEDORADMINISTRADOR,
      PERMITIONS.FORNECEDOROPERADORGST,
      PERMITIONS.FORNECEDOROPERADORNGT,
      PERMITIONS.FORNECEDOROPERADORHIBRIDO
    ],
    selected: false,
    subRoutes: [],
    title: 'Fale Conosco'
  }
] as IRoutes[]

const ngtRoutesList = [
  {
    icon: <DocumentMultiple className="icon_drawer" />,
    permition: [
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.CSNTI
    ],
    selected: false,
    subRoutes: [
      {
        disable: false,
        path: '/ngt/sindicato',
        permition: [
          PERMITIONS.NGTNORMATIVO,
          PERMITIONS.NGTANALISTA,
          PERMITIONS.ADMINISTRADOR,
          PERMITIONS.CSNTI
        ],
        selected: false,
        title: 'Sindicato'
      },
      {
        disable: false,
        path: '/ngt/cadastro-pendencia',
        permition: [
          PERMITIONS.NGTNORMATIVO,
          PERMITIONS.NGTANALISTA,
          PERMITIONS.ADMINISTRADOR,
          PERMITIONS.CSNTI
        ],
        selected: false,
        title: 'Cadastro de Itens - Pendência'
      },
      {
        disable: false,
        path: '/ngt/cadastro-fornecedor',
        permition: [
          PERMITIONS.NGTNORMATIVO,
          PERMITIONS.NGTANALISTA,
          PERMITIONS.ADMINISTRADOR,
          PERMITIONS.CSNTI
        ],
        selected: false,
        title: 'Fornecedor'
      },
      {
        path: 'voltar',
        permition: [],
        title: 'Voltar'
      }
    ],
    title: 'Cadastros'
  },
  {
    icon: <ContractIcon className="icon_drawer" />,
    permition: [
      PERMITIONS.GSTANALISTA,
      PERMITIONS.GSTNORMATIVO,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.CSNTI
    ],
    selected: false,
    subRoutes: [
      {
        disable: false,

        path: '/ngt/contratos-pesquisar',
        permition: [
          PERMITIONS.NGTNORMATIVO,
          PERMITIONS.NGTANALISTA,
          PERMITIONS.ADMINISTRADOR,
          PERMITIONS.CSNTI
        ],
        selected: false,
        title: 'Contrato'
      },
      {
        disable: false,
        path: '/ngt/acesso',
        permition: [
          PERMITIONS.GSTANALISTA,
          PERMITIONS.GSTNORMATIVO,
          PERMITIONS.NGTNORMATIVO,
          PERMITIONS.NGTANALISTA,
          PERMITIONS.ADMINISTRADOR,
          PERMITIONS.CSNCONTRAPARTE,
          PERMITIONS.CSNTI
        ],
        selected: false,
        title: 'Validação de Acesso'
      },
      {
        path: 'voltar',
        permition: [],
        title: 'Voltar'
      }
    ],
    title: 'Contratos'
  },
  {
    icon: <BriefCaseIcon className="icon_drawer" />,
    permition: [
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.CSNCONTRAPARTE,
      PERMITIONS.CSNTI
    ],
    selected: false,
    subRoutes: [
      {
        disable: false,
        path: '/movimentacao',
        permition: [
          PERMITIONS.NGTNORMATIVO,
          PERMITIONS.NGTANALISTA,
          PERMITIONS.ADMINISTRADOR,
          PERMITIONS.CSNCONTRAPARTE,
          PERMITIONS.CSNTI
        ],
        selected: false,
        title: 'Movimentação Mensal'
      },
      {
        disable: false,
        path: '/ngt/consolidacao-efetivo',
        permition: [
          PERMITIONS.NGTNORMATIVO,
          PERMITIONS.NGTANALISTA,
          PERMITIONS.ADMINISTRADOR,
          PERMITIONS.CSNTI
        ],
        selected: false,
        title: 'Consolidação Efetivo'
      },
      {
        disable: false,
        path: '/ngt/efetivos/cadastro-efetivo',
        permition: [PERMITIONS.CSNCONTRAPARTE, PERMITIONS.CSNTI],
        selected: false,
        title: 'Efetivo Lógico'
      },
      {
        path: 'voltar',
        permition: [],
        title: 'Voltar'
      }
    ],
    title: 'Efetivos'
  },
  {
    icon: <DocumentIcon className="icon_drawer" />,

    permition: [
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.CSNTI
    ],
    selected: false,
    subRoutes: [
      {
        disable: false,
        path: '/ngt/carteira-cre',
        permition: [
          PERMITIONS.NGTNORMATIVO,
          PERMITIONS.NGTANALISTA,
          PERMITIONS.ADMINISTRADOR,
          PERMITIONS.CSNTI
        ],
        selected: false,
        title: 'Carteira'
      },
      {
        disable: false,
        path: '/ngt/analise-cre',
        permition: [
          PERMITIONS.NGTNORMATIVO,
          PERMITIONS.NGTANALISTA,
          PERMITIONS.ADMINISTRADOR,
          PERMITIONS.CSNTI
        ],
        selected: false,
        title: 'Análise CRE'
      },
      {
        disable: false,
        path: '/ngt/analise-pendencia-cre',
        permition: [
          PERMITIONS.NGTNORMATIVO,
          PERMITIONS.NGTANALISTA,
          PERMITIONS.ADMINISTRADOR,
          PERMITIONS.CSNTI
        ],
        selected: false,
        title: 'Análise Pendências CRE'
      },
      {
        path: 'voltar',
        permition: [],
        title: 'Voltar'
      }
    ],
    title: 'CRE'
  },
  {
    icon: <FileCheckIcon className="icon_drawer" />,
    permition: [
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.CSNTI
    ],
    selected: false,
    subRoutes: [
      {
        disable: false,
        path: '/ngt/folha-registro',
        permition: [
          PERMITIONS.NGTNORMATIVO,
          PERMITIONS.NGTANALISTA,
          PERMITIONS.ADMINISTRADOR,
          PERMITIONS.CSNTI
        ],
        selected: false,
        title: 'Folha de Registro'
      },
      {
        path: 'voltar',
        permition: [],
        title: 'Voltar'
      }
    ],
    title: 'Bloqueio de Pagamento'
  },
  {
    icon: <AccountCardIcon className="icon_drawer" />,
    path: '/ngt/djur',
    permition: [
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.CSNTI
    ],
    selected: false,
    subRoutes: [],
    title: 'Atendimento DJUR'
  },
  {
    icon: <CardIcon className="icon_drawer" />,
    permition: [
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.CSNTI
    ],
    selected: false,
    subRoutes: [
      {
        disable: false,
        path: '/ngt/cadastro-convencao',
        permition: [
          PERMITIONS.NGTNORMATIVO,
          PERMITIONS.NGTANALISTA,
          PERMITIONS.ADMINISTRADOR,
          PERMITIONS.CSNTI
        ],
        selected: false,
        title: 'Acordo/Convenção'
      },
      {
        path: 'voltar',
        permition: [],
        title: 'Voltar'
      }
    ],
    title: 'Acordo/Convenção'
  },
  {
    icon: <GraphicIcon className="icon_drawer" />,
    permition: [
      PERMITIONS.CSNCONTRAPARTE,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.CSNTI
    ],
    selected: false,
    subRoutes: [
      {
        disable: false,
        path: '/ngt/relatorios-acesso',
        permition: [
          PERMITIONS.NGTNORMATIVO,
          PERMITIONS.NGTANALISTA,
          PERMITIONS.ADMINISTRADOR,
          PERMITIONS.CSNTI
        ],
        title: 'Relatório de Acesso'
      },
      {
        disable: false,
        path: '/ngt/relatorios-efetivos',
        permition: [
          PERMITIONS.NGTNORMATIVO,
          PERMITIONS.NGTANALISTA,
          PERMITIONS.ADMINISTRADOR,
          PERMITIONS.CSNTI
        ],
        title: 'Relatório de Efetivos'
      },
      {
        disable: false,
        path: '/ngt/relatorios-bloqueio',
        permition: [
          PERMITIONS.NGTNORMATIVO,
          PERMITIONS.NGTANALISTA,
          PERMITIONS.ADMINISTRADOR,
          PERMITIONS.CSNTI
        ],
        title: 'Relatórios de Bloqueio'
      },
      {
        disable: false,
        path: '/ngt/relatorio-cre',
        permition: [
          PERMITIONS.NGTNORMATIVO,
          PERMITIONS.NGTANALISTA,
          PERMITIONS.ADMINISTRADOR,
          PERMITIONS.CSNTI
        ],
        title: 'Relatório CRE'
      },
      {
        disable: false,
        path: '/ngt/relatorios-contratos-vigentes',
        permition: [
          PERMITIONS.NGTNORMATIVO,
          PERMITIONS.NGTANALISTA,
          PERMITIONS.ADMINISTRADOR,
          PERMITIONS.CSNTI
        ],
        title: 'Relatório Contratos Vigentes'
      },
      {

        disable: false,
        path: '/ngt/relatorios-contraparte',
        permition: [
          PERMITIONS.CSNCONTRAPARTE,
          PERMITIONS.NGTNORMATIVO,
          PERMITIONS.NGTANALISTA,
          PERMITIONS.ADMINISTRADOR,
          PERMITIONS.CSNTI
        ],
        title: 'Relatório Contraparte',




      },
      {
        disable: false,
        path: '/ngt/relatorios-contraparte',
        permition: [
          PERMITIONS.CSNCONTRAPARTE,

          //PERMITIONS.NGTANALISTA,
          PERMITIONS.ADMINISTRADOR,
          PERMITIONS.CSNTI
        ],
        title: 'Movimentação e Pagamento',




      },
      {
        disable: false,
        path: '/ngt/relatorio-cre',
        permition: [
          PERMITIONS.CSNCONTRAPARTE,
          //PERMITIONS.NGTANALISTA,
          PERMITIONS.ADMINISTRADOR,
          PERMITIONS.CSNTI
        ],
        title: 'Pendências Abertas',




      },

      {
        path: 'voltar',
        permition: [],
        title: 'Voltar'
      },

    ],
    title: 'Relatórios'
  },
  {
    icon: <BulletedIcon className="icon_drawer" />,
    path: '/ngt/parametrizacao',
    permition: [PERMITIONS.NGTNORMATIVO, PERMITIONS.ADMINISTRADOR, PERMITIONS.CSNTI, PERMITIONS.CSNSEGURANCALOGICA],
    selected: false,
    subRoutes: [],
    title: 'Parametrização'
  },
  {
    icon: <FileMultipleIcon className="icon_drawer" />,
    permition: [
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.ADMINISTRADOR
    ],
    selected: false,
    subRoutes: [
      {
        disable: false,
        path: '/ngt/arquivos/documentação',
        permition: [
          PERMITIONS.NGTNORMATIVO,
          PERMITIONS.NGTANALISTA,
          PERMITIONS.ADMINISTRADOR,
          PERMITIONS.CSNTI
        ],
        title: 'Arquivo Documentação - Trabalhista e Previdenciária'
      },
      {
        disable: false,
        path: '/ngt/arquivos/cadastro',
        permition: [
          PERMITIONS.NGTNORMATIVO,
          PERMITIONS.NGTANALISTA,
          PERMITIONS.ADMINISTRADOR,
          PERMITIONS.CSNTI
        ],
        title: 'Cadastro de Guarda de Documentos'
      },
      {
        path: 'voltar',
        permition: [],
        title: 'Voltar'
      }
    ],
    title: 'Arquivos'
  },
  {
    icon: <SearchIcon className="icon_drawer" />,
    path: '/ngt/jobs-enviados',
    permition: [
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.CSNTI
    ],
    selected: false,
    subRoutes: [],
    title: 'Consulta JOBS'
  },
  {
    icon: <PieChart className="icon_drawer" />,
    permition: [
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.CSNTI
    ],
    selected: false,
    subRoutes: [
      {
        disable: false,
        path: '/ngt/cockpit/cockpit-gerencial',
        permition: [
          PERMITIONS.NGTNORMATIVO,
          PERMITIONS.NGTANALISTA,
          PERMITIONS.ADMINISTRADOR,
          PERMITIONS.CSNTI
        ],
        title: 'Cockpit Gerencial'
      },
      {
        disable: false,
        path: '/ngt/cockpit/cockpit-analista',
        permition: [
          PERMITIONS.NGTNORMATIVO,
          PERMITIONS.NGTANALISTA,
          PERMITIONS.ADMINISTRADOR,
          PERMITIONS.CSNTI
        ],
        title: 'Cockpit Analista'
      },
      {
        path: 'voltar',
        permition: [],
        title: 'Voltar'
      }
    ],
    title: 'Cockpit'
  },
  {
    icon: <TalkToUsIcon className="icon_drawer" />,
    path: '/ngt/fale-conosco',
    permition: [
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.CSNTI
    ],
    selected: false,
    subRoutes: [],
    title: 'Fale Conosco'
  },
  {
    icon: <BugReportIcon className="icon_drawer" />,
    path: '/ngt/log',
    permition: [PERMITIONS.CSNTI],
    selected: false,
    subRoutes: [],
    title: 'Logs'
  }
] as IRoutes[]

const gstRoutesList = [
  {
    icon: <DocumentMultiple className="icon_drawer" />,
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.GSTANALISTA,
      PERMITIONS.GSTNORMATIVO,
      PERMITIONS.CSNTI
    ],
    selected: false,
    subRoutes: [
      {
        path: '/gst/pesquisa-por-contrato',
        permition: [
          PERMITIONS.ADMINISTRADOR,
          PERMITIONS.GSTANALISTA,
          PERMITIONS.GSTNORMATIVO,
          PERMITIONS.CSNTI
        ],
        selected: false,
        title: 'Pesquisa por Contrato'
      },
      {
        path: 'voltar',
        permition: [],
        title: 'Voltar'
      }
    ],
    title: 'Gerenciamento de Contrato'
  },
  {
    icon: <DocumentIcon className="icon_drawer" />,
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.GSTANALISTA,
      PERMITIONS.GSTNORMATIVO,
      PERMITIONS.CSNTI
    ],
    selected: false,
    subRoutes: [
      {
        path: '/gst/consulta-documentos',
        permition: [
          PERMITIONS.ADMINISTRADOR,
          PERMITIONS.GSTANALISTA,
          PERMITIONS.GSTNORMATIVO,
          PERMITIONS.CSNTI
        ],
        title: 'Consulta de Documentos'
      },
      {
        path: 'voltar',
        permition: [],
        title: 'Voltar'
      }
    ],
    title: 'Consulta Documentos / Pendências'
  },
  {
    icon: <AccountCardIcon className="icon_drawer" />,
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.GSTANALISTA,
      PERMITIONS.GSTNORMATIVO,
      PERMITIONS.CSNTI
    ],
    selected: false,
    subRoutes: [
      {
        path: '/gst/cadastro/itens-subitens-segurança',
        permition: [
          PERMITIONS.ADMINISTRADOR,
          PERMITIONS.GSTANALISTA,
          PERMITIONS.GSTNORMATIVO,
          PERMITIONS.CSNTI
        ],
        title: 'Itens e Subitens de Segurança'
      },
      {
        path: '/gst/cadastro/ocorrencia-acidente-trabalho',
        permition: [
          PERMITIONS.ADMINISTRADOR,
          PERMITIONS.GSTANALISTA,
          PERMITIONS.GSTNORMATIVO,
          PERMITIONS.CSNTI
        ],
        title: 'Ocorrência de Acidente de Trabalho'
      },
      {
        path: '/gst/cadastro/gradacao-multas',
        permition: [
          PERMITIONS.ADMINISTRADOR,
          PERMITIONS.GSTANALISTA,
          PERMITIONS.GSTNORMATIVO,
          PERMITIONS.CSNTI
        ],
        title: 'Gradação de Multas'
      },
      {
        path: 'voltar',
        permition: [],
        title: 'Voltar'
      }
    ],
    title: 'Cadastro'
  },
  {
    icon: <GraphicIcon className="icon_drawer" />,
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.GSTANALISTA,
      PERMITIONS.GSTNORMATIVO,
      PERMITIONS.CSNTI
    ],
    selected: false,
    subRoutes: [
      {
        path: '/gst/relatorios/itens-pendentes',
        permition: [
          PERMITIONS.ADMINISTRADOR,
          PERMITIONS.GSTANALISTA,
          PERMITIONS.GSTNORMATIVO,
          PERMITIONS.CSNTI
        ],
        title: 'Itens Pendentes'
      },
      // {
      //   path: '/gst/relatorios/geral',
      //   permition: [
      //     PERMITIONS.ADMINISTRADOR,
      //     PERMITIONS.GSTANALISTA,
      //     PERMITIONS.GSTNORMATIVO
      //   ],
      //   title: 'Geral'
      // },
      {
        path: '/gst/relatorios/dashboard',
        permition: [
          PERMITIONS.ADMINISTRADOR,
          PERMITIONS.GSTANALISTA,
          PERMITIONS.GSTNORMATIVO,
          PERMITIONS.CSNTI
        ],
        title: 'Dashboard'
      },
      {
        path: 'voltar',
        permition: [],
        title: 'Voltar'
      }
    ],
    title: 'Relatórios'
  },
  {
    icon: <BulletedIcon className="icon_drawer" />,
    permition: [PERMITIONS.ADMINISTRADOR, PERMITIONS.GSTNORMATIVO, PERMITIONS.CSNTI],
    selected: false,
    subRoutes: [
      {
        path: '/gst/parametrizacao',
        permition: [PERMITIONS.ADMINISTRADOR, PERMITIONS.GSTNORMATIVO, PERMITIONS.CSNTI],
        title: 'Parametrizacao'
      },
      {
        path: 'voltar',
        permition: [],
        title: 'Voltar'
      }
    ],
    title: 'Parametrização'
  },
  {
    icon: <SearchIcon className="icon_drawer" />,
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.GSTANALISTA,
      PERMITIONS.GSTNORMATIVO,
      PERMITIONS.CSNTI
    ],
    selected: false,
    subRoutes: [
      {
        path: '/gst/consulta-jobs',
        permition: [
          PERMITIONS.ADMINISTRADOR,
          PERMITIONS.GSTANALISTA,
          PERMITIONS.GSTNORMATIVO,
          PERMITIONS.CSNCONTRAPARTE,
          PERMITIONS.CSNTI
        ],
        title: 'Consulta Jobs'
      },
      {
        path: 'voltar',
        permition: [],
        title: 'Voltar'
      }
    ],
    title: 'Consulta JOBS'
  },
  {
    icon: <TalkToUsIcon className="icon_drawer" />,
    path: '/gst/fale-conosco',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.GSTANALISTA,
      PERMITIONS.GSTNORMATIVO,
      PERMITIONS.CSNTI
    ],
    selected: false,
    subRoutes: [],
    title: 'Fale Conosco'
  }
] as IRoutes[]

export const masterList = [
  ...supplierRoutesList,
  ...ngtRoutesList,
  ...gstRoutesList
]
export interface IRoutes {
  permition: number[]
  title: string
  subRoutes: ISubRoutes[]
  path?: string
  visible: boolean
  icon: ReactNode
  selected: boolean
}

export interface ISubRoutes {
  permition: number[]
  disable: boolean
  title: string
  path: string
  selected: boolean
}

// export interface IRoutesNGT {
//   title: string
//   subRoutes: ISubRoutesNGT[]
//   path?: string
//   icon: ReactNode
//   selected: boolean
// }

// export interface ISubRoutesNGT {
//   disable: boolean
//   permition: number[]
//   title: string
//   path: string
//   selected: boolean
// }
